import styled from "styled-components";

export const ChecklistLineWrapper = styled.div`
  display: flex;
  gap: 28px;
  flex-direction: column;
  position: relative;
  top: 28px;
`;

export const CheckWrapper = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 14px;
  padding: 4.5px 6px 6.5px;
  box-sizing: border-box;
`;

export const ChecklistRow = styled.div`
  display: flex;
  gap: 24px;
  position: relative;
  top: -28px;
  left: -28px;
`;

export const VerticalLine = styled.div`
  width: 1px;
  margin: 0 13.5px;
`;
